import { render, staticRenderFns } from "./LoanSettings.vue?vue&type=template&id=5b40e989"
import script from "./LoanSettings.vue?vue&type=script&lang=js"
export * from "./LoanSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports